'use strict';

/* Стили */
import '../css/site.scss';

/* Библиотеки */
import { initAccordion } from './modules/accordion/init-accordion.js';
import { initTabs } from './modules/tabs/init-tabs.js';
import { initModals } from './modules/modals/init-modals.js';
import { initForm } from './modules/form/init-form.js';

/* Скрипты */
import sliders from './modules/sliders.js/sliders';
import site from './modules/site.js';
import netRequests from './modules/netRequest.js';
import centers from './modules/centers.js';
import map from './modules/map.js';
import area from './modules/area.js';

window.addEventListener('DOMContentLoaded', () => {
  /* Закрытие вкладок аккордиона на блоке Этапы сдачи экзамена */
  (() => {
    const questions = document.querySelectorAll('.stages__question');
    
    if (questions.length > 0 && innerWidth < 768) {
        questions.forEach(question => {
          if (question.classList.contains('is-active')) {
            question.classList.remove('is-active');
          }
        })
    }
  })();

  initModals();
  initTabs();
  initAccordion();

  async function initNetRequests() {
    const list = await netRequests();

    initForm(list);
    centers(list);
    map(list);
    site();
  }
  
  area();
  initNetRequests();

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
    sliders();
  });
});
